import Vue from 'vue';
import Router from 'vue-router';
import EmptyRouterView from '@/components/EmptyRouterView/EmptyRouterView.vue';
import TokenService from './services/token.service';
import { SUPPORTED_SU } from '@/config/app.config';
import { getScreeningUnitNameFromID } from '@/config/app.config';
import moment from 'moment';
import LocalStoreService from './store/local.store';
import { GetterTypes } from './store-vuex/types';
import store from '@/store-vuex';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/:screening',
      component: EmptyRouterView, // must pass a component here
      children: [
        {
          path: '',
          name: 'home',
          redirect: 'login',
          meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: false,
          },
        },
        {
          path: 'login',
          name: 'login',
          component: () => import('./views/ParticipantIdentification/ParticipantIdentification.vue'),
          meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: true,
          },
        },
        {
          path: 'login/refusal',
          name: 'login-refusal',
          component: () => import('./views/ParticipantIdentification/ParticipantIdentification.vue'),
          meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: true,
          },
        },
        {
          path: ':partId/appointment-participant',
          name: 'appointment-participant',
          component: () => import('./views/AppointmentParticipant/AppointmentParticipant.vue'),
        },
        {
          path: ':partId/appointment-details',
          name: 'appointment-details',
          component: () => import('./views/Appointment-Details/AppointmentDetails.vue'),
          // meta: {
          //   public: true,  // Allow access to even if not logged in
          //   onlyWhenLoggedOut: true,
          // },
        },
        {
          path: ':partId/appointment-selection',
          name: 'appointment-selection',
          component: () => import('./views/AppointmentSelection/AppointmentSelection.vue'),
          // meta: {
          //   public: true,  // Allow access to even if not logged in
          //   onlyWhenLoggedOut: true,
          // },
        },
        {
          path: ':partId/recap',
          name: 'recap',
          component: () => import('./views/Recap/Recap.vue'),
          // meta: {
          //   public: true,  // Allow access to even if not logged in
          //   onlyWhenLoggedOut: true,
          // },
        },
        {
          path: 'confirmation',
          name: 'confirmation',
          component: () => import('./views/Confirmation/Confirmation.vue'),
        },
        {
          path: 'admin/translation',
          name: 'translation',
          component: () => import('./views/AdminTranslation/AdminTranslation.vue'),
          meta: {
            public: true,  // Allow access to even if not logged in
            onlyWhenLoggedOut: true,
          },
        },
      ],
    },
    {
      // Default behaviour if no screening is set in the URL
      path: '/',
      name: 'default',
      redirect: () => {
        const su = LocalStoreService.localItemKeys.screeningUnit;
        const redirectTo = LocalStoreService.itemExists(su) ?
          getScreeningUnitNameFromID(LocalStoreService.getItem(su)) + '/login' :
          `${process.env.VUE_APP_DEFAULT_ROUTE_PREFIX}/login`;
        return redirectTo;
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  },
});

router.beforeEach(async (to, from, next) => {
  const isPublic = to.matched.some((record) => record.meta.public);
  const onlyWhenLoggedOut = to.matched.some((record) => record.meta.onlyWhenLoggedOut);
  const loggedIn = TokenService.tokenExists() && (store.getters[GetterTypes.isIdentified]);
  const suName = to.params.screening;

  // Prevent the user to change pages without having the latest app version
  if (store.getters[GetterTypes.isAppLoaded]) {
    if (!store.getters[GetterTypes.appVersion].isLatest) {
      window.location.reload();
    } else {
      // If it's the latest version, check also the last time we checked it
      const a = moment(store.getters[GetterTypes.appVersion].lastCheckDate);
      const b = moment();
      if (b.diff(a, 'days') > 0) {
        window.location.reload();
      }
    }
  }

  if (suName !== undefined) {
    // Redirect to homepage if it's not a supported SU
    if (!SUPPORTED_SU.includes(suName.toLocaleLowerCase())) {
      return next({
        name: 'default',
      });
    }
  }

  if (!isPublic && !loggedIn) {
    //if not logged in and trying to access a restricted page, redirect to login page on the same screening unit
    if (suName) {
      return next({
        name: 'home',
        params: { screening: suName },
      });
    }
    return next({
      path: '/',
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  // Pro users should access to the login page in order to open the participant dossier
  if (loggedIn && onlyWhenLoggedOut) {
    return next({
      name: 'home',
    });
  }

  // Do not allow to come back after confirmation
  // Go back to login page
  if (from.name === 'confirmation' && !!to.name) {
    if (
      ['recap',
        'questionnary',
        'alternativeQuestionnaire',
        'appointment-selection',
        'appointment-details'].includes(to.name)) {
      return next({
        name: 'home',
      });
    }
  }

  next();
},

);

export default router;
